import './kitStyles';
import React from 'react';

/**
 * WEB-3310 юнит 1 — флажок и радио кита, эталон `Check({ checked, onChange,
 * label, round, name })`: `label.row-ctl > input.box` (+`.round` и `type=radio`
 * у радио). Клавиатура — родная у поля.
 * WEB-4177 юнит 1 — `disabled` по виду рескина (kit.jsx коммита b123724d):
 * заперто — у обёртки `row-ctl off`, у поля `disabled`; отметка видна.
 * `data-testid` ставится на сам орган `input.box`.
 */
export interface CheckProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: React.ReactNode;
  round?: boolean;
  name?: string;
  disabled?: boolean;
  'data-testid'?: string;
}

export function Check({
  checked,
  onChange,
  label,
  round,
  name,
  disabled,
  'data-testid': testId,
}: CheckProps): React.ReactElement {
  return (
    <label className={'row-ctl' + (disabled ? ' off' : '')}>
      <input
        type={round ? 'radio' : 'checkbox'}
        name={name}
        className={'box' + (round ? ' round' : '')}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
      />
      <span>{label}</span>
    </label>
  );
}
